import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import IntermediateAcc from "./IntermediateAcc";
const defaultAutos = {
    Branches: [],
};

export default function IntermedateCon() {
  
  
  const tb = {
    wait: true,
    Branch: true,
    costcenters:true,
    Users:true,
    AllMedAccounts:true,
    AllAccountsIndex:true,
    stor: sto,

    parms: { 
        tname:"intermed" , 
        iempid: sto.empi,
        branch:sto.branchi
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions?.Branches) return <LoadingPage />;

  return (
    <IntermediateAcc
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        isDialog:true,
      }}
    />
  );
}
